<template>
    <div>
        <label class="requered" for="language">{{language.label}}</label>
        <select class="form-control" v-validate="'required'" :name="language.name" aria-describedby="selectLanguage" @change="changeLanguage($event)">
            <option value="he_IL" :selected = "language.selected === 'he_IL'">Hebrew</option>
            <option value="ru_RU" :selected = "language.selected === 'ru_RU'">Russian</option>
        </select>
        <span class="span-valid-text" v-show="errors.has('language')" >{{ errors.first('language') }} </span>
    </div>  
</template>
 
<script> 
  export default {   
    data() {      
      return {        
        language: this.$store.getters.LANGUAGE_ENTITY,
      };
    },
    methods: {
        changeLanguage(e){
            console.log("changeLanguage lang obj: ", this.language)           
            if(this.language.onSelectCB !== ''){
                this.language.onSelectCB(e);
            }
        },     
    },
    created(){
      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'INIT_LANGUAGE_ENTITY'){
             this.language = this.$store.getters.LANGUAGE_ENTITY
          }
      })
      console.log("languge input",  this.$store.getters.LANGUAGE_ENTITY)
    }
  };
</script> 